// Symbol polyfill has to be loaded before React. Otherwise React sometimes can't recognize React element
// https://github.com/facebook/react/issues/8379
import React from 'react';
import ReactDOM from 'react-dom';
import MessageBusTransport from '@central-products/message-transport-bus';
import cookies from 'browser-cookies';
import { publish } from '@wh/message-bus';
import { bootstrap } from '@central-products/bootstrapper';
import './config/publicPathConfiguration';
import getBootstrapFeatures from './getBootstrapFeatures';
import getBootstrapConfig from './getBootstrapConfig';
import {
  requiredBootstrapFeatures,
  deviceType,
  headerConfig,
  translations,
  serviceUrl,
  locale,
  domain,
} from './config';
import { APP_ROOT_ID } from '../const';
import { REGISTRATION_OPEN } from './topics';
import App from './components/App';

const requiredPolyfills = [];

if (!window.AbortController) {
  requiredPolyfills.push(
    import(/* webpackChunkName: "polyfills" */ 'abortcontroller-polyfill/dist/polyfill-patch-fetch')
  );
}

const checkRegilyRegistration = () => {
  const regilyIdenWasOpen = cookies.get('RegilyRegistrationIden');
  if (regilyIdenWasOpen === 'true') {
    publish(REGISTRATION_OPEN, {});
  }
};

const bootstrapApp = (bootstrapFeatures, bootstrapConfig) => {
  const { init } = bootstrap(MessageBusTransport.getInstance(), bootstrapFeatures, bootstrapConfig);
  init();
  checkRegilyRegistration();
};

const renderApp = (bootstrapConfig) => {
  ReactDOM.render(
    <App
      clientSide
      deviceType={deviceType}
      bootstrapConfig={bootstrapConfig}
      headerConfig={headerConfig}
      translations={translations}
      serviceUrl={serviceUrl}
      locale={locale}
      domain={domain}
    />,
    document.getElementById(APP_ROOT_ID)
  );
};

// eslint-disable-next-line promise/catch-or-return
Promise.all(requiredPolyfills).then(() => {
  const bootstrapFeatures = getBootstrapFeatures(requiredBootstrapFeatures, deviceType);
  const bootstrapConfig = getBootstrapConfig(bootstrapFeatures);
  renderApp(bootstrapConfig);
  bootstrapApp(bootstrapFeatures, bootstrapConfig);
});
